<script>
    import VueSelect from "./vue-select/src/index"

    /**
     * RwlSelect is wrapper for <a href="https://vue-select.org/">vue-select</a>
     * @version 1.0.0
     */
    export default {
        name: "RwlSelect",
        inheritAttrs: false,
        functional: true,
        status: "prototype",
        release: "1.0.0",
        render: function (createElement, context) {
            context.data.class = "rwl-select";
            VueSelect.name = "RwlSelect";
            return createElement(VueSelect, context.data, context.children);
        }
    }
</script>

<docs>
    ```jsx
    <div>
        <rwl-select :options="['test1', 'test2', 'test3']">
            <template v-slot:option="option">
                {{ option.label }}
            </template>
        </rwl-select>
        <rwl-select :searchable="true" :options="['test1', 'test2', 'test3']"></rwl-select>
        <rwl-select placeholder="Search country" :options="[{label: 'Canada', code: 'ca'}]"></rwl-select>
    </div>
    ```
</docs>
